import { z } from "zod";

export const pagingFormSchema = z.object({
  page: z.string({ message: "page는 숫자여야 합니다" }).regex(/^\d+$/, { message: "page는 숫자여야 합니다" }).transform(Number).pipe(z.number().min(1)),
});

export type Paging = z.infer<typeof pagingFormSchema>;


